export class FittingRequestForm extends BX.Event.EventEmitter
{
    constructor(formNode) 
    {
        super();
        this.setEventNamespace('Mario.FittingRequest.Form');

        this.formNode = formNode;
        this.bindEvents();
    }

    bindEvents() 
    {
        if (!this.formNode) {
            return;
        }
        
        this.formNode.addEventListener('submit', e => this.onSubmit(e));
        [...this.formNode.elements].forEach(element => {
            if (!this.shouldValidate(element)) {
                return;
            }

            $(element).on('input', () => this.cleanValidation(element));
            $(element).on('change', () => this.cleanValidation(element));
        });
    }

    cleanValidation(input) 
    {
        input.setCustomValidity('');
        input.classList.remove('was-validated');
    }

    showInputError(input, msg)
    {
        input.setCustomValidity(msg);
        BX.Dom.replace(
            input.parentNode.querySelector('.invalid-feedback'),
            BX.Tag.render`<div class="invalid-feedback">${msg}</div>`, 
        );
    }

    validate() 
    {
        let result = true;

        [...this.formNode.elements].forEach(element => {
            if (!this.shouldValidate(element)) {
                return;
            }

            if (!element.checkValidity()) {
                this.showInputError(element, 'Введите корректный номер телефона');
                result = false;
            } else if (element.dataset.entity === 'phone-input') {
                if (!this.validatePhone(element)) {
                    this.showInputError(element, 'Введите корректный номер телефона');
                    result = false;
                }
            }

            element.classList.add('was-validated');
        });

        return result;
    }

    validatePhone(input)
    {
        const value = $(input).inputmask('unmaskedvalue');
        return /^[0-9]{10}$/.test(value);
    }

    shouldValidate(element)
    {
        if (!('checkValidity' in element) || element.type === 'hidden' || element.tagName === 'BUTTON') {
            return false;
        }

        return true;
    }

    async onSubmit(e) 
    {
        e.preventDefault();

        if (!this.validate()) {
            return;
        }

        const button = this.formNode.querySelector('button[type="submit"]');
        BX.Dom.addClass(button, 'btn__loading')

        try {
            await this.sendRequest();
            this.emit('success');
        } catch(e) {
            console.error(e);
        } finally {
            setTimeout(() => BX.Dom.removeClass(button, 'btn__loading'), 2000)
        }
    }

    sendRequest()
    {
        const phone = this.formNode.querySelector('[data-entity="phone-input"]')?.value;
        const data = JSON.parse(this.formNode.querySelector('[data-entity="products-data"]')?.value);
        const source = this.formNode.querySelector('[data-entity="source"]')?.value;;

        return new Promise((resolve, reject) => {
            $.post(`/ajax/product/fitting_request/`, { phone, data, source }, null, 'json')
            .then(() => resolve()).catch(reject);
        });
    }
}

export class FittingRequestPopup 
{
    static get DEFAULT_OPTIONS() 
    {
        return {
            mobileBreakpoint: 991,
            showAfter: 0,
            ymPrefix: ''
        };
    }

    constructor(rootNode, options = {}) 
    {
        this.rootNode = rootNode;
        this.backdropNode = null;
        this.options = BX.Runtime.merge({}, FittingRequestPopup.DEFAULT_OPTIONS, options);
        
        const formNode = this.rootNode.querySelector('form');
        this.form = new FittingRequestForm(formNode);

        this.isOpen = false;
        
        this.bindEvents();

        setTimeout(() => this.showPopup(), this.options.showAfter);
    }

    bindEvents() 
    {
        this.rootNode.querySelector('[data-entity="close"]')?.addEventListener('click', () => {
            this.closePopup();
        });

        BX.Event.EventEmitter.subscribe('Mario:FittingRequestModal:shown', () => {
            this.closePopup();
        });

        BX.Event.EventEmitter.subscribe('Mario:CardV2:add2basket_popup_shown', () => {
            this.closePopup();
        });

        this.form.subscribe('success', () => this.onSuccess());
    }

    onSuccess()
    {
        BX.Dom.replace(
            this.rootNode.querySelector('[data-entity="body"]'),
            BX.Tag.render`
                <div class="cart-fitting__body" data-entity="body">
                    <div class="card-fitting__success">Менеджер уже Вам звонит</div>
                </div>
            `
        );

        setTimeout(() => this.closePopup(), 3000);

        this.reachGoal('fr_success');
    }

    showPopup() 
    {
        if (document.querySelector('#fitting-modal')) {
            return;
        }

        const rootNode = this.rootNode;

        const handleAnimationEnd = function() {
            BX.Dom.removeClass(rootNode, 'animate fadeInBottom30');
            rootNode.removeEventListener('animationend', handleAnimationEnd);
        };
        rootNode.addEventListener('animationend', handleAnimationEnd);

        BX.Dom.removeClass(rootNode, 'hidden');
        BX.Dom.addClass(rootNode, 'animate fadeInBottom30');

        if (this.isMobile() && !this.backdropNode) {
            this.backdropNode = BX.Tag.render`<div class="card-fitting-backdrop"></div>`;
            BX.Dom.append(this.backdropNode, document.body);
            this.backdropNode.addEventListener('click', () => this.closePopup());
        }

        this.isOpen = true;

        this.reachGoal('fr_show');
        BX.Event.EventEmitter.emit('Mario:FittingRequestPopup:shown');
    }

    closePopup() 
    {
        if (!this.isOpen) {
            return;
        }
        
        const rootNode = this.rootNode;

        const handleAnimationEnd = function() {
            BX.Dom.removeClass(rootNode, 'animate fadeInBottom');
            rootNode.removeEventListener('animationend', handleAnimationEnd);
            BX.Dom.addClass(rootNode, 'hidden');
        };
        rootNode.addEventListener('animationend', handleAnimationEnd);

        BX.Dom.addClass(rootNode, 'animate fadeOutTop30');

        if (this.backdropNode) {
            const handleBackdropTransitionEnd = () => {
                this.backdropNode.removeEventListener('transitionend', handleBackdropTransitionEnd);
                this.backdropNode.remove();
                this.backdropNode = null;
            };
            
            this.backdropNode.addEventListener('transitionend', handleBackdropTransitionEnd);
            this.backdropNode.style.opacity = 0;
        }
        
        this.isOpen = false;
        this.reachGoal('fr_hide');
    }

    isMobile() 
    {
        return window.matchMedia(`(max-width: ${this.options.mobileBreakpoint}px)`).matches;
    }

    reachGoal(name)
    {
        if ('ym' in window) {
            ym(window._store?.state?.ym_id, 'reachGoal', `${(this.options.ymPrefix || '')}${name}`);
        }
    }
}

export class FittingRequestModal
{
    static get DEFAULT_OPTIONS() 
    {
        return {
            ymPrefix: '',
        };
    }

    constructor(rootNode, options = {}) 
    {
        this.rootNode = rootNode;
        this.options = BX.Runtime.merge({}, FittingRequestPopup.DEFAULT_OPTIONS, options);
        
        this.formNode = this.rootNode.querySelector('form');
        this.form = new FittingRequestForm(this.formNode);

        $(this.formNode).find('.js-phone').inputmask('+7 (999) 999-99-99');
        
        this.init();
        this.bindEvents();
    }

    init()
    {
        this.reachGoal('fr_modal_init');
        BX.Event.EventEmitter.emit('Mario:FittingRequestModal:shown');
        
        window.rebindBasketItemButtons();
        this.fillProductsData();
    }

    fillProductsData()
    {
        const productsData = [];
        window._store.state.basket.addedIds.forEach(id => {
            const itemNode =  this.rootNode.querySelector(`.js-basket_item[data-id="${id}"]`);

            if (itemNode) {
                productsData.push({ id: itemNode.dataset.id, name: itemNode.dataset.name })
            }
        });

        const productsDataInput = this.formNode.querySelector('[data-entity="products-data"]');
        productsDataInput.value = JSON.stringify(productsData)
    }

    bindEvents() 
    {
        window._store.subscribe(window._EventTypes.BASKET_UPDATED, () => this.fillProductsData());
        this.form.subscribe('success', () => this.onSuccess());

        $(this.rootNode).on('hidden.bs.modal', () => {
            $(this.rootNode).remove();
        });
    }

    onSuccess()
    {
        BX.Dom.replace(
            this.rootNode.querySelector('[data-entity="content"]'),
            BX.Tag.render`
                <div class="fitting-modal__success" data-entity="content">
                    <div class="fitting-modal__success-icon">
                        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="30" cy="30" r="30" fill="#EF476F"/>
                            <path d="M30.7895 28.9056V26.5408C33.4642 26.173 35.5263 23.9619 35.5263 21.2974C35.5263 18.3772 33.0474 16.0002 30 16.0002C26.9526 16.0002 24.4737 18.3772 24.4737 21.2974H26.0526C26.0526 19.2111 27.8234 17.5137 30 17.5137C32.1766 17.5137 33.9474 19.2111 33.9474 21.2974C33.9474 23.3837 32.1766 25.0811 30 25.0811H29.2105V28.9049C21.2929 29.3226 15 35.9077 15 44.0002H45C45 35.9077 38.7071 29.3226 30.7895 28.9056ZM30 30.379C36.8961 30.379 42.5945 35.686 43.3389 42.4868H16.6611C17.4055 35.686 23.1039 30.379 30 30.379Z" fill="white"/>
                        </svg>
                    </div>
                    <div class="fitting-modal__success-content">
                        <div class="fitting-modal__success-title">Спасибо за заявку!</div>
                        <div class="fitting-modal__success-text">Менеджер уже связывается с Вами.</div>
                    </div>
                </div>
            `
        );

        this.reachGoal('fr_modal_success');
    }

    reachGoal(name)
    {
        if ('ym' in window) {
            ym(window._store?.state?.ym_id, 'reachGoal', `${(this.options.ymPrefix || '')}${name}`);
        }
    }
}